import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { gql } from '@/__generated__';
import { Stream } from '@/__generated__/schema-types';
import { streamTiers } from '@/constants/stream-tiers';

const TierPackageStreamsQuery = gql(`
  query TierPackageStreamsQuery($id: ID!) {
    streamPackage(id: $id) {
      id
      includedStreams {
        id
        ...StreamCardFragment
        canAddToStreamDeck
        polymatcherEnabled
        accessAllowed
        following
        customTargetsData {
          ...CustomTargetsDataFragment
        }
      }
    }
  }
`);

const NO_STREAMS: Stream[] = [];

const useTierPackageQuery = (packageId?: string) => {
  const { data, loading } = useQuery(TierPackageStreamsQuery, {
    variables: { id: packageId ?? '' },
    skip: !packageId,
  });

  return {
    streams:
      (data?.streamPackage?.includedStreams as Stream[] | undefined) ??
      NO_STREAMS,
    isLoading: loading,
  };
};

export const useTierPackageStreams = (packageId?: string): Stream[] =>
  useTierPackageQuery(packageId).streams;

export const useTier1Streams = () => {
  const { streams, isLoading } = useTierPackageQuery(
    streamTiers.tier1.packageId,
  );
  const ids = useMemo(
    () => new Set(streams.map((stream) => stream.id)),
    [streams],
  );

  return { streams, ids, isLoading };
};
